import { IntlShape } from "react-intl";
import * as v from "valibot";

const schema = (intl: IntlShape) =>
  v.pipe(
    v.object({
      requiresApproval: v.boolean(),
      noCode: v.boolean(),
      useJuryScore: v.boolean(),
      privateApprovals: v.boolean(),
      showMetric: v.boolean(),
    }),
    v.forward(
      v.partialCheck(
        [["useJuryScore"], ["requiresApproval"]],
        ({ useJuryScore, requiresApproval }) =>
          !useJuryScore || requiresApproval,
        intl.formatMessage({
          defaultMessage:
            "This feature is available only when approval is required",
        }),
      ),
      ["useJuryScore"],
    ),
    v.forward(
      v.partialCheck(
        [["noCode"], ["requiresApproval"]],
        ({ noCode, requiresApproval }) => !noCode || requiresApproval,
        intl.formatMessage({
          defaultMessage:
            "This feature is available only when approval is required",
        }),
      ),
      ["noCode"],
    ),
  );

export type Schema = v.InferOutput<ReturnType<typeof schema>>;

export { schema };
